import React from "react";

interface TransProps {
  value?: string | null;
  components: Record<string, React.ReactElement>;
}

const parseSegment = (
  text: string | null | undefined,
  components: Record<string, React.ReactElement>,
  keyPrefix: string
): React.ReactNode[] => {
  if (typeof text !== "string" || text.length === 0) {
    return [];
  }

  const tagPattern = /<(\w+)>(.*?)<\/\1>/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = tagPattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const [, tag, content] = match;
    const element = components[tag];
    const children = parseSegment(content, components, `${keyPrefix}_${match.index}`);
    if (element) {
      parts.push(React.cloneElement(element, { key: `${keyPrefix}_${match.index}` }, ...children));
    } else {
      parts.push(...children);
    }
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};

export const Trans: React.FC<TransProps> = ({ value, components }) => {
  return <>{parseSegment(value, components, "t")}</>;
};
